import { AfterViewInit, Component, ElementRef, OnInit, Query, ViewChild } from '@angular/core';
import { extend } from 'jquery';
import { EditFieldComponent } from '../../edit-field.component';
declare let laydate: any;
@Component({
  selector: 'app-field-dateTime',
  templateUrl: './field-dateTime.component.html',
  styleUrls: ['./field-dateTime.component.sass']
})
export class FieldDateTimeComponent extends EditFieldComponent  implements OnInit, AfterViewInit {

  @ViewChild('getInput', { static: true }) input: ElementRef
  @ViewChild('DateTime', {static: true}) Date: ElementRef
  @ViewChild('Time', {static: true}) Time: ElementRef
  public laydate:any
  public date: any
  public time: any 
  public dateData: any
  public timeData: any
  public isRange:any
  public isCurrenDay:any
  public isCurrenTime:any
  public signDate:any
  public isNeedSignDate:boolean = false
  public lastValidDateTime:string
  private resizeListenerAdded: boolean = false;
  private resizeTimeout: any;
  ngOnInit() {
    //console.log(this.value)
    //console.log(this.value, this.handler,'e.target' )
    if(this.handler.fieldLabel=="Date & Time"){
        this.isRange = true
    }
    if(this.handler.fieldName == 'customField44'){
      // 检查 document.getElementById('customField44') 是否为 null
      const element = document.getElementById('customField44');
      this.signDate = element ? (element.getAttribute('customfield44_time') || '').split(" ") : null;
      this.isNeedSignDate = true
    }
    
    const focusOutEvnet = (e:any) => {
        if(e.target !== this.input.nativeElement){
          this.handler.onFocusOut()
        }
        focusOutEvent
        document.removeEventListener('click',focusOutEvnet)
    }
    if(this.value){
    let  data = this.value.split(' ')
      this.dateData = data[0]
      this.timeData = data[1]
    } else {
      this.dateData = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.timeData = '00:00:00'
    }
    this.lastValidDateTime = this.dateData + ' ' + this.timeData
    let lang = 'cn'
    if(this.I18n.locale == 'zh-CN' || this.I18n.locale == 'zh-TW') {
     lang = 'cn'
    } else {
      lang = 'en'
    }
    this.getCurrentDate()
    let date = this.isRange? 0:'1900-1-1'
    if(this.isNeedSignDate){
        date=this.signDate[0]
    }
  this.date = laydate.render({
        elem: this.Date.nativeElement,
        position: 'static',
        value: this.dateData,
        zIndex: 99999999,
        btns: [],
        min: date ,//7天前
        // max: this.isRange? 0:'2099-12-31' ,
        lang,
        change: (value:any) => {
          this.dateData = value
          this.value =  this.dateData + ' ' + this.timeData
          this.Time.nativeElement.children[0].remove()
          this.getCurrentDate()
          let minTime = this.getMinTimeForDate(this.dateData)
          if (this.toSeconds(this.timeData) < this.toSeconds(minTime)) {
            this.timeData = minTime
            alert('The selected date and time are invalid')
            this.handler.setErrors(['invalid'])
            this.value = this.dateData + ' ' + this.timeData
          } else {
            this.handler.setErrors([])
            this.lastValidDateTime = this.value
          }
          this.time = laydate.render({
            elem: this.Time.nativeElement,
            type: 'time',
            value: this.timeData,
            position:'static',
            zIndex: 99999999,
            min:minTime,
            lang,
            btns: ['confirm'],
            change: (value: any)=> {
              this.timeData = value
              this.value =  this.dateData + ' ' + this.timeData
              this.validateOnChange('time')
              document.removeEventListener('click',focusOutEvnet)
            }
          })
          this.ngAfterViewInit()
          this.addClick(focusOutEvnet)
        }
      });
      let newTime = this.getMinTimeForDate(this.dateData)
  this.time = laydate.render({
        elem: this.Time.nativeElement,
        type: 'time',
        value: this.timeData,
        position:'static',
        zIndex: 99999999,
        min:newTime,
        lang,
        btns: ['confirm'],
        change: (value: any)=> {
          this.timeData = value
          this.value =  this.dateData + ' ' + this.timeData
          this.validateOnChange('time')
          document.removeEventListener('click',focusOutEvnet)
        }
      });
    let focusOutEvent = document.addEventListener('click', focusOutEvnet)
    jQuery('.laydate-footer-btns').click(() => {
      this.handler.onFocusOut()
      document.removeEventListener('click',focusOutEvnet)
     })
  }
  addClick(focusOutEvnet:any){
    let focusOutEvent = document.addEventListener('click', focusOutEvnet)
    jQuery('.laydate-footer-btns').click(() => {
     this.handler.onFocusOut()
     document.removeEventListener('click',focusOutEvnet)
    })
  }
  getCurrentDate(){
      // if(!this.isRange) return
      
      const targetDate = new Date(this.dateData);
      
      // 获取当前日期
      const currentDate = new Date();
       // 计算当前日期加一天的日期
      const nextDayDate = new Date(currentDate);
      nextDayDate.setDate(currentDate.getDate());
      // 提取年份、月份和日期部分进行比较
      if(this.dateData){
        if (nextDayDate.getFullYear() === targetDate.getFullYear() &&
            nextDayDate.getMonth() === targetDate.getMonth() &&
            nextDayDate.getDate() === targetDate.getDate()) {
            this.isCurrenDay = true
        } else {
            this.isCurrenDay = false
        }
      }else{
        this.isCurrenDay =true
      }

          // 获取小时（0-23），并格式化为两位数
        const hours = this.padToTwoDigits(currentDate.getHours());
        
        // 获取分钟（0-59），并格式化为两位数
        const minutes = this.padToTwoDigits(currentDate.getMinutes());
        
        // 获取秒（0-59），并格式化为两位数
        const seconds = this.padToTwoDigits(currentDate.getSeconds());
        this.isCurrenTime = hours+':'+minutes+':'+seconds
        //console.log(this.isCurrenTime,this.isCurrenDay,'isCurrenDay');
  }
  padToTwoDigits(number:any) {
      return number.toString().padStart(2, '0');
  }

  public validateOnChange(source:'date'|'time') {
    const minTime = this.getMinTimeForDate(this.dateData)
    if (this.isNeedSignDate) {
      if (this.dateData < this.signDate[0]) {
        this.dateData = this.signDate[0]
        this.timeData = this.getMinTimeForDate(this.dateData)
        alert('The selected date and time are invalid')
        this.handler.setErrors(['invalid'])
        this.value = this.dateData + ' ' + this.timeData
        return
      }
      if (this.dateData === this.signDate[0] && this.toSeconds(this.timeData) < this.toSeconds(this.signDate[1])) {
        this.timeData = minTime
        alert('The selected date and time are invalid')
        this.handler.setErrors(['invalid'])
        this.value = this.dateData + ' ' + this.timeData
        return
      }
    }
    if (this.isRange && this.isCurrenDay) {
      if (this.toSeconds(this.timeData) < this.toSeconds(minTime)) {
        this.timeData = minTime
        alert('The selected date and time are invalid')
        this.handler.setErrors(['invalid'])
        this.value = this.dateData + ' ' + this.timeData
        return
      }
    }
    this.handler.setErrors([])
    this.lastValidDateTime = this.value
  }

  private getMinTimeForDate(dateStr:string):string {
    let minTime = '00:00:00'
    if (this.isRange && this.isCurrenDay) {
      minTime = this.isCurrenTime
    }
    if (this.isNeedSignDate && dateStr === this.signDate[0]) {
      const t = this.signDate[1]
      if (this.toSeconds(t) > this.toSeconds(minTime)) {
        minTime = t
      }
    }
    return minTime
  }

  private toSeconds(time:string):number {
    const [h, m, s] = time.split(':').map((v)=> parseInt(v, 10))
    return h*3600 + m*60 + s
  }
  ngAfterViewInit() {
    // Set responsive width based on screen size
    const isMobile = window.innerWidth < 680;
    const pickerWidth = isMobile ? 'calc(100vw - 40px)' : '245px';
    const maxPickerWidth = isMobile ? '320px' : 'none';

    // Apply width constraints to all layui containers
    jQuery('.layui-laydate').css({
      'width': pickerWidth,
      'max-width': maxPickerWidth,
      'overflow': 'hidden',
      'box-sizing': 'border-box'
    });
    jQuery('.layui-laydate-main').css({
      'width': pickerWidth,
      'max-width': maxPickerWidth,
      'box-sizing': 'border-box'
    });

    document.getElementsByClassName('laydate-time-list')
    this.Time.nativeElement.children[0].children[0].children[1].children[1].children[2].remove()
    this.Time.nativeElement.children[0].children[0].children[1].children[1].children[0].style.width = '50%'
    this.Time.nativeElement.children[0].children[0].children[1].children[1].children[1].style.width = '50%'

    setTimeout(()=> {
      this.input.nativeElement.focus()
    }, 10)

    // Add window resize listener for dynamic adjustment
    if (!this.resizeListenerAdded) {
        this.resizeListenerAdded = true;
        window.addEventListener('resize', () => {
            this.adjustPickerSize();
        });
    }
  }

  private adjustPickerSize(): void {
    // Debounce resize events
    if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = setTimeout(() => {
        const isMobile = window.innerWidth < 680;
        const pickerWidth = isMobile ? 'calc(100vw - 40px)' : '245px';
        const maxPickerWidth = isMobile ? '320px' : 'none';

        // Apply width constraints to all layui containers
        jQuery('.layui-laydate').css({
          'width': pickerWidth,
          'max-width': maxPickerWidth,
          'overflow': 'hidden',
          'box-sizing': 'border-box'
        });
        jQuery('.layui-laydate-main').css({
          'width': pickerWidth,
          'max-width': maxPickerWidth,
          'box-sizing': 'border-box'
        });
    }, 250);
  }

}
